import { render, staticRenderFns } from "./ExtendApplicationBox.vue?vue&type=template&id=190db70d&"
import script from "./ExtendApplicationBox.vue?vue&type=script&lang=js&"
export * from "./ExtendApplicationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports